var _excluded = ["colorScheme", "size", "variant", "children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef } from '../../system';
import { createContext, cx } from '../../utils';
import * as React from 'react';
import { useRadioGroup } from './use-radio-group';
var [RadioGroupProvider, useRadioGroupContext] = createContext({
  name: 'RadioGroupContext',
  strict: false
});
export { useRadioGroupContext };
export var RadioGroup = forwardRef((props, ref) => {
  var {
      colorScheme,
      size,
      variant,
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var {
    value,
    onChange,
    getRootProps,
    name,
    htmlProps
  } = useRadioGroup(rest);
  var group = React.useMemo(() => ({
    name,
    size,
    onChange,
    colorScheme,
    value,
    variant
  }), [size, name, onChange, colorScheme, value, variant]);
  var groupProps = getRootProps(htmlProps, ref);
  var _className = cx('tqc-radio-group', className);
  return /*#__PURE__*/React.createElement(RadioGroupProvider, {
    value: group
  }, /*#__PURE__*/React.createElement(tqc.div, _extends({}, groupProps, {
    className: _className
  }), children));
});